module.exports = __webpack_public_path__ + "img/cover-artikel-1.3a0ca960.png";